import { termsAndConditionConstants } from "@/actions/constants/termsAndConditionConstants";
import { failure, request, success } from "@/utils/constants";

export const termsAndConditionReducer = (state = {}, action: any) => {
    switch (action.type) {
        case termsAndConditionConstants.termsAndConditionRequest:
            return {
                ...request,
            };
        case termsAndConditionConstants.termsAndConditionSuccess:
            return {
                ...success,
                data: action.payload,
            };
        case termsAndConditionConstants.termsAndConditionFailure:
            return {
                ...failure,
            };
        default:
            return state;
    }
};

export const termsOfServiceReducer = (state = {}, action: any) => {
    switch (action.type) {
        case termsAndConditionConstants.termsofServiceRequest:
            return {
                ...request,
            };
        case termsAndConditionConstants.termsofServiceSuccess:
            return {
                ...success,
                data: action.payload,
            };
        case termsAndConditionConstants.termsofServiceFailure:
            return {
                ...failure,
            };
        default:
            return state;
    }
};

export const privacyPolicyReducer = (state = {}, action: any) => {
    switch (action.type) {
        case termsAndConditionConstants.privacyPolicyRequest:
            return {
                ...request,
            };
        case termsAndConditionConstants.privacyPolicySuccess:
            return {
                ...success,
                data: action.payload,
            };
        case termsAndConditionConstants.privacyPolicyFailure:
            return {
                ...failure,
            };
        default:
            return state;
    }
};